// meeting-list-sort.ts — Tri de la vue liste de #meetings-records.
//
// Extrait de `renderMeetingsPage` (cliquet fonction, août 2026). Dérivation
// pure : aucun accès à window/document, aucun appel à `t()`.

import type { MeetingRecord } from '../modules/page-meetings-records.js';

export type SortKey =
  | 'id'
  | 'label'
  | 'project_code'
  | 'committee_code'
  | 'meeting_date'
  | 'participants_count'
  | 'animators_count'
  | 'notes_count';

/** Copie triée. Comportement identique à l'inline d'origine. */
export function sortMeetings(
  rows: readonly MeetingRecord[],
  key: SortKey,
  dir: 'asc' | 'desc',
): MeetingRecord[] {
  const value = (m: MeetingRecord): string | number => {
    switch (key) {
      case 'label':
        return m.label.toLowerCase();
      case 'project_code':
        return (m.project_code || '').toLowerCase();
      case 'committee_code':
        return m.committee_code || '';
      case 'meeting_date':
        return m.meeting_date || '';
      case 'participants_count':
        return m.participants.length;
      case 'animators_count':
        return m.animators.length;
      case 'notes_count':
        return m.notes_count;
      default:
        return m.id;
    }
  };
  return [...rows].sort((a, b) => {
    const va = value(a);
    const vb = value(b);
    if (va < vb) return dir === 'asc' ? -1 : 1;
    if (va > vb) return dir === 'asc' ? 1 : -1;
    return 0;
  });
}
